// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"4c97eeab","218":"753ac552","307":"c7b8a94a","436":"15ce7ad6","505":"9f316cdf","814":"4d5663c8"}[chunkId] + ".chunk.js";
};